export function handleResponse(response) {
    if(!response.ok) {    
        throw Error(response.statusText);
    }
    return response.json() 
}

export function catchError(error) {
    if(error.message === 'Unauthorized') {
        window.location.replace("/TimeOut");
    }
    else {
        window.location.replace("/Error");
    }
}

export function getHeaders() {
    let headers = new Headers();
    headers.append('Cache-Control', 'no-store');

    return headers;
}


// WEBPACK FOOTER //
// ./src/utils/Response.js